import React from 'react';
import { connect } from 'react-redux';
import ModalPopover from '../../../../../../components/ZUILib/ModalPopover';
import commonUtil from '../../../../../../utils/commonUtil';
import * as defaultConst from '../../../../../../utils/clientConstant';
import serverClientUtil from '../../../../../../utils/serverClientUtil';

const applicationRoutes = commonUtil.getApplicationRoutes();
class BrandSelectionModal extends React.Component {
  // showThankyouPopup = this.props.showThankyouPopup;
  componentDidMount() {
    commonUtil.addTransition();
    this.modal.handleShow();
  }


  componentWillUnmount() {
    this.modal.handleHide();
  }
  // dismissDelete() {
  //   this.modal.handleHide();
  // }

  hideModal = () => {
    this.modal.handleHide();
  }
  showModal = () => {
    this.modal.handleShow();
  }
  getDisplayStyle = (brand) => {
    if (brand === commonUtil.getBrand()) {
      return 'hide';
    }
    return '';
  }
  render() {
    const lables = this.props.lables;

    const lpGRURL = serverClientUtil.getMultiSiteURL(defaultConst.constBrand.LP) + applicationRoutes.home;
    const wsGRURL = serverClientUtil.getMultiSiteURL(defaultConst.constBrand.WS) + applicationRoutes.home;
    const pbGRURL = serverClientUtil.getMultiSiteURL(defaultConst.constBrand.PB) + applicationRoutes.home;
    const gapGRURL = serverClientUtil.getMultiSiteURL(defaultConst.constBrand.GAP) + applicationRoutes.home;
    const pbkGRURL = serverClientUtil.getMultiSiteURL(defaultConst.constBrand.PBK) + applicationRoutes.home;
    const weGRURL = serverClientUtil.getMultiSiteURL(defaultConst.constBrand.WLM) + applicationRoutes.home;
    const truGRURL = serverClientUtil.getMultiSiteURL(defaultConst.constBrand.TRU) + applicationRoutes.home;

    return (

      <div id="adminModal">
        <ModalPopover header={commonUtil.getLabel(lables.EventAdminPage, 'adminpage.regalosregistrados.multisitios.label')} modalId="brandsModal" dataBackDrop="false" isModal="true" ref={modal => this.modal = modal} >
          <div className="modalMultisite">
            <p>{commonUtil.getLabel(lables.EventAdminPage, 'adminpage.regalosregistrados.multisitios.message')} </p>
            <ul>
              <li className={this.getDisplayStyle(defaultConst.constBrand.LP)}><a rel="noopener noreferrer" target="_blank" href={lpGRURL}><img src={commonUtil.getAssetURL() + '/images/admin/lvModal.png'} alt="Liver Pool" /></a></li>
              <li className={this.getDisplayStyle(defaultConst.constBrand.WS)}><a rel="noopener noreferrer" target="_blank" href={wsGRURL}><img src={commonUtil.getAssetURL() + '/images/admin/wsModal.png'} alt="Williams Sonoma" /></a></li>
              <li className={this.getDisplayStyle(defaultConst.constBrand.PB)}><a rel="noopener noreferrer" target="_blank" href={pbGRURL}><img src={commonUtil.getAssetURL() + '/images/admin/pbModal.png'} alt="Potery Barn" /></a></li>
              <li className={this.getDisplayStyle(defaultConst.constBrand.PBK)}><a rel="noopener noreferrer" target="_blank" href={pbkGRURL}><img src={commonUtil.getAssetURL() + '/images/admin/pbkModal.png'} alt="Potery Barn Kids" /></a></li>
              <li className={this.getDisplayStyle(defaultConst.constBrand.GAP)}><a rel="noopener noreferrer" target="_blank" href={gapGRURL}><img src={commonUtil.getAssetURL() + '/images/admin/gapModal.png'} alt="GAP" /></a></li>
              <li className={this.getDisplayStyle(defaultConst.constBrand.WLM)}><a rel="noopener noreferrer" target="_blank" href={weGRURL}><img src={commonUtil.getAssetURL() + '/images/admin/whModal.png'} alt="West Elm" /></a></li>
              {serverClientUtil.enableIconToys && <li className={this.getDisplayStyle(defaultConst.constBrand.TRU)}><a rel="noopener noreferrer" target="_blank" href={truGRURL}><img src={commonUtil.getAssetURL() + '/images/admin/truModal.png'} alt="Toys R Us" /></a></li>}
            </ul>
            <div id="modalTip">
              <p>{commonUtil.getLabel(lables.EventAdminPage, 'adminpage.regalosregistrados.multisitios.tip.message')} </p>
            </div>
          </div>
        </ModalPopover>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  showThankyouPopup: state.contractPage.showThankyouPopup,
});

export default connect(mapStateToProps, undefined)(BrandSelectionModal);
